import React from 'react';
import { Trans } from 'react-i18next';
import EmailLink from './presentation/email-link';

const generateEmailTransComponentsObject = (link, links, linkFunctionality) => {
    let components = {
        strong: <strong />,
        b: <strong />,
        error: <span style={{ color: '#F00707' }} />,
        lighter: <div className="lighter" />,
        themed: <div style={{ color: '#8132A8' }} />,
        pseudoLink: (
            <span style={{ color: '#0521E5', textDecoration: 'underline' }} />
        ),
        lt: '<',
        gt: '>',
    };

    if (link)
        components['u'] = addLinkComponent(
            link,
            linkFunctionality.handleLinkClick,
            linkFunctionality.handleLinkMouseLeave,
            linkFunctionality.handleLinkMouseEnter
        );
    if (links) {
        {
            links.map((link, index) => {
                return (components['u' + (index + 1)] = addLinkComponent(
                    link,
                    linkFunctionality.handleLinkClick,
                    linkFunctionality.handleLinkMouseLeave,
                    linkFunctionality.handleLinkMouseEnter
                ));
            });
        }
    }

    return components;
};

const addLinkComponent = (
    link,
    handleLinkClick,
    handleLinkMouseLeave,
    handleLinkMouseEnter
) => {
    return (
        <EmailLink
            onClick={handleLinkClick}
            onMouseLeave={handleLinkMouseLeave}
            onMouseEnter={handleLinkMouseEnter}
            link={link}
        />
    );
};

/**
 * A component which handles our default Assessment Email Trans usage.
 * Replacing predefined tags in translation values with the correct HTML elements
 *
 * @param translatedString The string to send to trans, after translation and interpolation (if any)
 * @param link {Object} Use if the text contains a single link whose activity we want to score (click, hover etc.)
 * @param links {Array} Use if there are multiple links withing the text
 * @param linkFunctionality {Object} The click and hover functionality handlers. Expects the handlers to be {handleLinkClick,
 *             handleLinkMouseLeave,
 *             handleLinkMouseEnter}
 * @returns {JSX.Element} i18next <Trans object
 */
const EmailTrans = ({ translatedString, link, links, linkFunctionality }) => {
    return (
        <Trans
            components={generateEmailTransComponentsObject(
                link,
                links,
                linkFunctionality
            )}
        >
            {translatedString}
        </Trans>
    );
};

export default EmailTrans;
